<template>
  <div>
    <!--<div class="d-flex justify-content-between align-items-center">-->
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center"
         style="padding-bottom: inherit;min-heigth:30px;">
      <!--<h3 class="mb-0">{{ $t('profile.notifications.title') }}</h3>-->
      <h4>{{$t('profile.notifications.title')}}</h4>
      <i
          v-if="showPreviewToggle"
          id="previewToogle"
          class="fa ml-4 green-icon"
          :class="{'fa-chevron-up': isOpen, 'fa-chevron-down': !isOpen}"
          @click="isOpen = !isOpen"
      >
      </i>
    </div>

    <div v-if="isOpen">
      <div v-if="!hasLoaded" id="loading-section">
        <!--<h6><b>{{$t('tables.loading')}}</b></h6>-->
        <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
      <div v-else>
        <div class="d-flex justify-content-end align-items-center">
          <Searchable
            :querySearch.sync="querySearch"
            class="mr-3">
          </Searchable>
          <i
            class="fa fa-exchange green-icon"
            :class="{'animated': performAnimation}"
            @click="toogleViewOption"
          >
          </i>
        </div>
        <component
          v-show="hasFinishedTransition"
          :key="currentView.id"
          :is="currentView.component"
          :search="querySearch"
          :notifications="notifications"
          :userNotifications.sync="userNotifications"
          @updatedUserNotifications="updatedUserNotifications"
          @finishedMount="hasFinishedMount"
        >
        </component>
        <div v-if="!hasFinishedTransition" class="text-center">
          <h5><b>{{ $t('tables.loading') }}</b></h5>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Notifications, UserNotifications} from '@/api/Notifications'
import ViewByNotification from './ViewByNotification'
import ViewByEntity from './ViewByEntity'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'
import Searchable from '@/components/common/Searchable'

export default {
  components: {
    LoadingAnimation,
    Searchable
  },
  props: {
    showPreviewToggle: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function () {
    return {
      notifications: [],
      userNotifications: [],
      hasLoaded: false,
      hasFinishedTransition: true,
      isOpen: true,
      querySearch: '',
      viewOptions: [
        {
          id: 1,
          component: ViewByNotification
        },
        {
          id: 2,
          component: ViewByEntity
        }
      ],
      currentView: undefined,
      performAnimation: false
    }
  },
  created() {
    //let userId = this.$auth.user().id
    let userId = this.$route.params.id ? this.$route.params.id : this.$auth.user().id
    Promise.all([Notifications.all(), UserNotifications.get(parseInt(userId))])
      .then(values => {
        this.notifications = values[0]
        this.userNotifications = values[1]
        this.hasLoaded = true
      })
      .catch(errors => console.log(errors))
  },
  mounted() {
    this.currentView = this.viewOptions[0]
  },
  methods: {
    hasFinishedMount: function () {
      this.hasFinishedTransition = true
    },
    toogleViewOption: function () {
      this.hasFinishedTransition = false

      this.performAnimation = true
      setTimeout(() => {
        this.performAnimation = false
      }, 500)

      setTimeout(() => {
        if (this.currentView.id === 1) {
          this.currentView = this.viewOptions[1]
        } else {
          this.currentView = this.viewOptions[0]
        }
      }, 500)
    },
    updatedUserNotifications: function (userNotifications) {
      this.showToast(this.$t('profile.notifications.user_notifications_updated'), this.$store.state.successToastOptions)
      this.userNotifications = userNotifications
    }
  }
}
</script>

<style lang="scss" scoped>

.fa {
  color: #29c4a9 !important;
  cursor: pointer;
}

.fa.fa-exchange {
  font-size: 1.3rem;
}

.animated {
  animation: spin 500ms infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
</style>

<style lang="scss">

@media (min-width: 801px) {
  #notifications-table th:nth-child(1) {
    width: 40%;
  }

  #notifications-table th:nth-child(2) {
    width: 50%;
  }

  #notifications-table th:nth-child(3) {
    width: 10%;
  }
}

#notifications-table tr {
  height: 45px;
}

.custom-tag {
  margin-right: 10px;
  padding: 0.4em 1em;
  background: #29c4a9;
  color: white;
  border-radius: 1em;
  font-weight: 100;
  font-size: 13px;
  white-space: nowrap;
}

.green-icon {
  color: #29c4a9;
  cursor: pointer;
}

</style>

<!-- Multiselect CSS -->

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect .multiselect__tag {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background: #21ab93 !important;
}

.multiselect__clear {
  position: absolute;
  right: 33px;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
  z-index: 2;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 12px;
  background: #C0C0C0;
  top: 15px;
  right: 4px;
}

.multiselect__clear:after {
  transform: rotate(-45deg);
}

.multiselect__clear:before {
  transform: rotate(45deg);
}

.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #29c4a9;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  cursor: pointer;
}

.custom__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  border-radius: 5px;
}

.custom__tag-icon:focus, .custom__tag-icon:hover {
  background: #21ab93;
}

.custom__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}

.custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
  color: #fff;
}

.multiselect__content-wrapper {
  max-height: 250px !important;
}
</style>
